import { render, staticRenderFns } from "./WarehouseTransferReceivePage.vue?vue&type=template&id=9ff48eee&"
import script from "./WarehouseTransferReceivePage.vue?vue&type=script&lang=ts&"
export * from "./WarehouseTransferReceivePage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9ff48eee')) {
      api.createRecord('9ff48eee', component.options)
    } else {
      api.reload('9ff48eee', component.options)
    }
    module.hot.accept("./WarehouseTransferReceivePage.vue?vue&type=template&id=9ff48eee&", function () {
      api.rerender('9ff48eee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/logistic/warehouse-transfer/WarehouseTransferReceivePage.vue"
export default component.exports